import Vue from 'vue'
import App from './App'

new Vue(App);